/**
 * Small pill that renders a transaction type — "Debit" or "Credit".
 *
 * Normalises the incoming value (accepts "Debit", "Credit", "debit", "credit",
 * "purchase", "payment", "refund" etc.) so it can be dropped into any list
 * that surfaces card / statement / bill activity.
 *
 * - Debit  → stone / neutral
 * - Credit → emerald / positive
 */
export default function TxnTypeBadge({ value, className = "" }) {
    const norm = normalise(value);
    if (!norm) {
        return <span className={`text-xs text-stone-400 ${className}`}>—</span>;
    }
    const tone =
        norm === "Credit"
            ? "text-emerald-700 border-emerald-200 bg-emerald-50"
            : "text-stone-700 border-stone-200 bg-stone-50";
    return (
        <span
            data-testid={`txn-type-${norm.toLowerCase()}`}
            className={`inline-flex items-center px-1.5 py-0.5 rounded border text-[10.5px] font-medium uppercase tracking-widest ${tone} ${className}`}
        >
            {norm}
        </span>
    );
}

function normalise(v) {
    if (v == null) return null;
    const s = String(v).trim().toLowerCase();
    if (!s) return null;
    if (["credit", "cr", "refund", "reversal", "cashback", "payment"].includes(s)) return "Credit";
    if (["debit", "dr", "purchase", "spend"].includes(s)) return "Debit";
    // Sensible fallback — anything else that isn't clearly a credit is a debit
    return "Debit";
}
